import React from 'react';

export default function RunbookPlaySVG() {
  return (
    <svg
      height="1em"
      viewBox="0 0 12 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.838867 15.1709V2.11652L9.81373 8.63735L0.838867 15.1709Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
}
